import { render } from "./ContactsNewEntityDialog.vue?vue&type=template&id=fb67db84"
import script from "./ContactsNewEntityDialog.vue?vue&type=script&lang=js"
export * from "./ContactsNewEntityDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__